export const numbers = [
    {
      id: 0,
      number: 1,
    },
    {
      id: 1,
      number: 2,
    },
    {
      id: 2,
      number: 3,
    },
    {
      id: 3,
      number: 4,
    },
    {
      id: 4,
      number: 5,
    },
    {
      id: 5,
      number: 6,
    },
    {
      id: 6,
      number: 7,
    },
    {
      id: 7,
      number: 8,
    },
    {
      id: 8,
      number: 9,
    },
    {
      id: 9,
      number: 10,
    },
    {
      id: 10,
      number: 11,
    },
    {
      id: 11,
      number: 12,
    },
    {
      id: 12,
      number: 13,
    },
  ];
  
  export const colors = [
    {
      id: 0,
      color: "red",
    },
    {
      id: 1,
      color: "black",
    },
  ];
  
  export const symbols = [
    {
      id: 0,
      symbol: "♠",
      name: "spade",
    },
    {
      id: 1,
      symbol: "♥",
      name: "heart",
    },
    {
      id: 2,
      symbol: "♣",
      name: "club",
    },
    {
      id: 3,
      symbol: "♦",
      name: "diamond",
    },
  ];